import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {
  paginationleftarrow,
  paginationrightarrow,
  paginationleftarrowdouble,
  paginationrightarrowdouble,
} from '../assets/images/index';

interface PaginationProps {
  rowsPerPageOptions?: number[];
  currentPage?: number;
  initialRowsPerPage?: number | string;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
  totalPages?: number;
}

const Pagination: React.FC<PaginationProps> = ({
  rowsPerPageOptions = [],
  currentPage = 1,
  initialRowsPerPage = 5,
  onPageChange,
  onRowsPerPageChange,
  totalPages = 1,
}) => {
  const [rowsPerPage, setRowsPerPage] = useState<number | string>(
    initialRowsPerPage,
  );

  const goToFirstPage = () => {
    onPageChange(1);
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const goToLastPage = () => {
    onPageChange(totalPages);
  };

  const handleRowsPerPageChange = (
    e: SelectChangeEvent<typeof rowsPerPage>,
  ) => {
    const value = e.target.value;
    setRowsPerPage(value);
    onRowsPerPageChange(
      typeof value === 'number' ? value : parseInt(value as string, 10),
    );
  };

  return (
    <div className="pagination">
      <div className="pagination-controls">
        <p>Rows per page</p>
        <Select
          value={rowsPerPage}
          className="rows-per-page-dropdown"
          onChange={handleRowsPerPageChange}
        >
          {rowsPerPageOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </div>
      <div className="pagination-nav-controls">
        <IconButton className="pagination-btn" onClick={goToFirstPage}>
          <img
            src={paginationleftarrowdouble}
            alt="pagination left arrow"
            className="pagination-btn-icon"
          />
        </IconButton>
        <IconButton className="pagination-btn" onClick={goToPrevPage}>
          <img
            src={paginationleftarrow}
            alt="pagination left arrow"
            className="pagination-btn-icon"
          />{' '}
        </IconButton>
        <p className="pagenumber">
          {currentPage} of {totalPages}
        </p>
        <IconButton className="pagination-btn" onClick={goToNextPage}>
          <img
            src={paginationrightarrow}
            alt="pagination left arrow"
            className="pagination-btn-icon"
          />{' '}
        </IconButton>
        <IconButton className="pagination-btn" onClick={goToLastPage}>
          <img
            src={paginationrightarrowdouble}
            alt="pagination left arrow"
            className="pagination-btn-icon"
          />
        </IconButton>
      </div>
    </div>
  );
};

const MemoizedComponent = React.memo(Pagination);
export default MemoizedComponent;
